/**
* 业务代码：M0002
* 业务名称：账户资料-视频见证
*/

<template>
    <div class="QS421_mobile_video_witness"> 
        <mobileVideoWitness ref="M0002WitnessInPersonRef" @on-next-click="nextStep" :bizData="bizData" :historyData="historyData" :oppBusiData="oppBusiData" :isDisabled="isDisablePage"/>
    </div>
</template>


<script>
 
import mobileVideoWitness from "@/components/imageNode/mobile_video_witness";

export default {
   data () { 
     return {
           
     };
   },
   props: ["bizData", "historyData", "oppBusiData", "isDisablePage"],  
   mounted () {
       
   },
   computed: { },
   components: {
     mobileVideoWitness,
   },
   methods: {
     pageActivated (_this){
       _this.hideFooter(false);
     },
     nextStep () {
       this.$emit("on-next-click");
     },
     validate (_this) {
       var that = _this.$refs["M0002_mobile_video_witness"];
       return that.$refs["M0002WitnessInPersonRef"].validate(that.$refs["M0002WitnessInPersonRef"], _this);
     },
     preValidate (_this) {
       var that = _this.$refs["M0002_mobile_video_witness"];
       return that.$refs["M0002WitnessInPersonRef"].preValidate(that.$refs["M0002WitnessInPersonRef"], _this);
     },
     beforeSave (_this, params, baseData) {
       var that = _this.$refs["M0002_mobile_video_witness"];
       return that.$refs["M0002WitnessInPersonRef"].beforeSave(that.$refs["M0002WitnessInPersonRef"], params, baseData);
 
     },
     afterSave (_this) {
       var that = _this.$refs["M0002_mobile_video_witness"];
       return that.$refs["M0002WitnessInPersonRef"].afterSave(that.$refs["M0002WitnessInPersonRef"], _this);
     }
   }
};
</script>


<style lang="less"  scoped>
.QS421_mobile_video_witness {
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/business/businessFile/QS421/QS421_mobile_video_witness.vue